import { render, staticRenderFns } from "./ChatEventUserPhoto.vue?vue&type=template&id=3818ec84&"
import script from "./ChatEventUserPhoto.vue?vue&type=script&lang=js&"
export * from "./ChatEventUserPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports